module.exports = __webpack_public_path__ + "media/images/icon-goto-top-3e3c114ef2fb5cc748a6be180df878d3.svg";